// @flow

import * as React from 'react';
import Box from 'sail/Box';
import Group from 'sail/Group';
import {useAccount, useArticle} from 'docs/data';
import {Actions} from './Actions';
import {Overlays} from './Overlays';
import {Filename} from './Filename';
import {PublicUrl} from './PublicUrl';
import {Type} from './Type';
import {Owner} from './Owner';
import {FlagsList} from './FlagsList';
import {GatesList} from './GatesList';
import {TranslationUtilsSection} from './TranslationUtilsSection';
import {ConditionsList} from './ConditionsList';

import './XRaySidebarContent.scss';

type XRaySidebarContentProps = {|
  hide: () => any,
|};

export const XRaySidebarContent = ({hide}: XRaySidebarContentProps) => {
  const {account} = useAccount();
  const {article, isLoading} = useArticle();

  // TODO (nkohari): A visible error message would be better here
  if (!account.xray || !article.xray) {
    console.warn('Missing necessary x-ray data. Please contact #docs!'); // eslint-disable-line no-console
    return null;
  }

  return (
    <Box flexGrow={1} padding={{horizontal: 20}} className="XRaySidebarContent">
      {!isLoading && (
        <Group spacing={20} flexGrow={1}>
          <Filename article={article} />
          <PublicUrl article={article} />
          <Type article={article} />
          <Owner article={article} />
          <Actions account={account} article={article} />
          <Overlays account={account} article={article} />
          <ConditionsList article={article} />
          <FlagsList article={article} />
          <GatesList article={article} />
          <TranslationUtilsSection article={article} />
        </Group>
      )}
    </Box>
  );
};
